<template>
    <div style="background:white!important">
        <div class="tab-list d-flex align-items-center justify-content-between">
            <ul class="d-flex align-items-center pl-4 mb-0 mt-7">
                <li class="d-flex align-items-center ml-5 px-3 pointer" @click="switchTab('work_shift')" :class="{'active': work_shift_active}">
                    <span class="list-text" :class="{'active': work_shift_active}">Work Shift List</span>
                    <span class="mx-2">|</span>
                    <span class="list-text-count">{{work_data_length}} Total</span>
                </li>
                <li class="d-flex align-items-center pointer px-3 ml-3" @click="switchTab('employee_list')" :class="{'active': employee_list_active}">
                    <span class="list-text" :class="{'active': employee_list_active}">Employee List</span>
                    <span class="mx-2">|</span>
                    <span class="list-text-count">{{total}} Total</span>
                </li>
            </ul>
            <div v-if="employee_list_active">
                <button @click="createEmployee" class="btn btn-success text-white text-capitalize">
                    Add Shift To Employee
                </button>
            </div>
            <div v-if="work_shift_active">
                <button @click="createWorkShift" style="width:180px" class="btn btn-success text-white text-capitalize">
                    Add New Shift
                </button>
            </div>
        </div>
        <div class="content mt-3">
            <div v-if="employee_list_active">
                <div v-if="ajax_call_in_progress" class="position-relative">
                    <hollow-dots-spinner :animation-duration="1000" :dot-size="17" :dots-num="3" color="#00448f" class="text-center w-100 d-flex justify-content-center position-relative"/>
                </div>
                <div v-else>
                    <configure-shift-employee-list-view :passed_list_data="list_data" @emp_data_length="empDataLength" @createEmpSuccess="createEmpSuccess"></configure-shift-employee-list-view>
                    <div class="d-flex align-items-center font-weight-bold mt-2 justify-content-end" v-if="total > 0">
                        <multiselect class="diginew-multiselect dd-ht multiple-select-arrow-hide"
                            :options="pageLimit" :close-on-select="true" v-model.number="limit"
                            @search-change="fetchListData"
                            open-direction="top" :show-labels="false" placeholder=""
                            style="width: 5.3em !important;padding-right: 10px!important;"></multiselect>
                        <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/down-arrow-grey.svg"
                            style="margin-left: -35px;">
                        <span class="page-info pr-2 pl-6 fw-500"
                            style="height: 2.4rem;line-height: 2.4rem;color: #4e5764;font-size: 12px;">Per page</span>
                        <button @click="firstPage()" :disabled="skip == 0" class="mt-1 pointer pagination-list">
                            <el-tooltip class="item" effect="dark" content="First Page" placement="top">
                                <i class="icon-chevron-double-left"></i>
                            </el-tooltip>    
                        </button>
                        <button @click="previousPage()" :disabled="skip == 0" class="pagination-list mt-1 ml-2 pointer">
                            <el-tooltip class="item" effect="dark" content="Previous Page" placement="top">
                                <i class="icon icon-chevron-left"></i>
                            </el-tooltip>    
                        </button>
                        <span class="px-2 fw-500 fs-14 mt-1">Showing {{getSkipCount}} - {{total>skip+limit?skip+limit:total}} of {{total}}</span>
                        <button @click="nextPage()" :disabled="skip_temp >= total" class="pagination-list mt-1 mr-2 pointer">
                            <el-tooltip class="item" effect="dark" content="Next Page" placement="top">
                                <i class="icon icon-chevron-right"></i>
                            </el-tooltip>    
                        </button>
                        <button @click="lastPage()" class="mt-1 pointer pagination-list" :disabled ="temp_total == total">
                            <el-tooltip class="item" effect="dark" content="Last Page" placement="top">
                                <i class="icon-chevron-double-right"></i>
                            </el-tooltip>    
                        </button>
                    </div>
                </div>
            </div>
            <div v-if="work_shift_active">
                <configure-shift-work-list-view @work_data_length="workDataLength" ></configure-shift-work-list-view>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { EventBus } from '../../eventBus/nav-bar-event';
import facility_mgmt from '../../mixins/facility_mgmt';
const ConfigureShiftEmployeeListView = () => import('./ConfigureShiftEmployeeListView');
const ConfigureShiftWorkListView = () => import('./ConfigureShiftWorkListView');
import { SweetModal } from 'sweet-modal-vue';
export default {
    mixins: [facility_mgmt],
    components: { 
        ConfigureShiftEmployeeListView,
        ConfigureShiftWorkListView, 
        SweetModal
    },
    data(){
        return{
            employee_list_active: false,
            work_shift_active: true,
            work_data_length: 0,
            list_data: [],
            ajax_call_in_progress: false,
            skip:0,
            limit:10,
            total:0,
            temp_total:0,
            search_key:'',
            pageLimit: [],
            skip_temp: 0,
            count:0,
            pageLimit: [],
        }
    },
    methods:{
        switchTab(tab){
            if(tab == 'employee_list'){
                this.employee_list_active = true
                this.work_shift_active = false
                this.fetchListData();
            }else if (tab == 'work_shift'){
                this.employee_list_active = false
                this.work_shift_active = true
            }
        },
        createEmpSuccess() {
            this.fetchListData();
        },
        createEmployee(){
            EventBus.$emit('addEmployee');
        },
        createWorkShift() {
            EventBus.$emit('addWorkShift');
        },
        empDataLength(data){
            this.emp_data_length = data;
        },
        workDataLength(data){
            this.work_data_length = data;
        },
        async fetchListData(){
            this.ajax_call_in_progress = true;
            this.list_data = [];
            try {
                let params = {
                    skip: this.skip,
                    limit: this.limit,
                    search_key: this.search_key.trim(),
                };
                let response = await this.getEmployeeShiftList(params);
                this.list_data = response.response.employee_shifts
                this.total = response.response.count;
                this.ajax_call_in_progress = false;
            }
            catch (error) {
                this.warning_msg = error;
                this.$refs.warning_modal.open();
            }
        },
        firstPage(){
            this.temp_total = 0
            this.skip = 0
            this.limit = 10
            this.list_data = []
            this.fetchListData()
        },
        lastPage(){
            this.skip_temp = 0
            this.skip = 0
            this.temp_total = this.total
            let no_of_pages = Math.ceil(this.total/this.limit)
            this.skip_temp = (no_of_pages * this.limit) - this.limit
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp
            this.fetchListData();
        },
        nextPage() {
            this.skip_temp = this.skip + this.limit > this.total ? this.total : this.skip + this.limit;
            if (this.skip_temp >= this.total) {
                return;
            }
            this.skip = this.skip_temp;
            this.fetchListData();
        },
        previousPage() {
            this.skip_temp = 0
            this.temp_total = 0
            if (this.skip == 0) {
                return;
            }
            this.skip = this.skip - this.limit <= 0 ? 0 : this.skip - this.limit;
            this.fetchListData();
        },
    },
    mounted() {
        for (let i = 10; i <= 50; i+=10) {
            this.pageLimit.push(i);
        }
        // this.fetchListData();
    },
    watch: {
        limit: function(){
            this.fetchListData();
        }
    },
    computed: {
        getSkipCount(){
            if(this.total == 0) {
                return 0
            } else {
                let skip_count = this.skip>this.total?this.total:this.skip+1;
                return skip_count;
            }
        },
    }
}
</script>
<style scoped>
    .tab-list .list-text{
        font-size: 14px;
        font-weight: 500;
        font-weight: 600;
        color: #000;
    }
    .tab-list .list-text-count{
        font-size: 14px;
        font-weight: 500;
        font-weight: 600;
        color: rgba(54, 54, 54, 0.61);
    }
    .tab-list .list-text.active {
        color: #005dae;
    }
    .tab-list li {
        padding-bottom: 5px;
    }
    .tab-list li.active {
        border-bottom: #005dae solid 2px;
    }
</style>